import { Code as CodeIcon, Cloud as CloudIcon, Psychology as PsychologyIcon } from '@mui/icons-material';

export   const specializations = [
    {
      title: 'Full-Stack Development',
      icon: <CodeIcon fontSize="large" />,
      description: 'Experienced in building responsive web applications using React, Node.js, and various databases.',
    },
    {
      title: 'Cloud-Native Applications',
      icon: <CloudIcon fontSize="large" />,
      description: 'Proficient in AWS services including S3, Lambda, SageMaker, API Gateway, and Bedrock.',
    },
    {
      title: 'Machine Learning',
      icon: <PsychologyIcon fontSize="large" />,
      description: 'Skilled in developing ML/DL pipelines for data analysis and predictive modeling.',
    },
  ];